export function billingTaxLabel(taxBehavior?: string): string {
    if (taxBehavior === 'exclusive') return 'excluding VAT';
    if (taxBehavior === 'inclusive') return 'including VAT';

    return 'VAT confirmed at checkout';
}
